import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from "@angular/core";
import { GameSettingsService } from "../../game-settings.service";

@Component({
  selector: "app-cash-prize-images",
  templateUrl: "./cash-prize-images.component.html",
  styleUrls: ["./cash-prize-images.component.scss"],
  encapsulation: ViewEncapsulation.Emulated, // Use Emulated, Native, or None
})
export class CashPrizeImagesComponent implements OnInit {
  @Input() prizeIndex: number;
  @Input() s3BucketUrl: string;
  @Input() cashPrizeImagesOptions: any;
  @Input() isMatchEditor: boolean = false;
  @Input() assignEmojisToInviteImageArt;

  @Output() extraImagesDelete = new EventEmitter<{
    index: number;
    item: any;
  }>();
  @Output() shuffle = new EventEmitter<number>();

  cashPrizeValue: string | null = null;

  constructor(public gameSettingsService: GameSettingsService) {}

  @Input() droppedEmojis: any[];

  emojiDropOptions: any;

  ngOnInit(): void {
    if (
      this.gameSettingsService.winPattern &&
      this.gameSettingsService.winPattern[this.prizeIndex]
    ) {
      this.cashPrizeValue =
        this.gameSettingsService.winPattern[this.prizeIndex].cashPrizeValue;
    }

    this.emojiDropOptions = {
      group: {
        name: "emojis",
        pull: false,
        // only allow drops if fewer than 6 items already
        put: () => {
          const images =
            this.gameSettingsService.winPattern[this.prizeIndex]
              .cashPrizeImages;
          return this.cashPrizeValue && images.length < 6;
        },
      },
      sort: true,
      filter: ".is-placeholder", // ❌ prevent dragging placeholders
      onAdd: (event) => {
        const sourceList = this.assignEmojisToInviteImageArt;
        const oldIndex = event.oldIndex;
        const newIndex = event.newIndex;
        const targetList =
          this.gameSettingsService.winPattern[this.prizeIndex].cashPrizeImages;

        // guard against bad indexes
        if (oldIndex == null || newIndex == null) return;

        // pull only id + image from your source model
        const { id, image } = sourceList[oldIndex];
        const newItem = { id, image };

        // dedupe by id
        if (targetList.some((e) => e.id === id)) return;

        // insert at the drop position
        targetList.splice(newIndex, 0, newItem);
      },
    };
  }

  // Helper to generate empty slots
  get emptySlots(): any[] {
    if (
      !this.gameSettingsService.winPattern ||
      !this.gameSettingsService.winPattern[this.prizeIndex]
    ) {
      return new Array(6);
    }
    const currentCount =
      (this.gameSettingsService.winPattern[this.prizeIndex].cashPrizeImages || [])
        .length || 0;
    const count = Math.max(0, 6 - currentCount);
    return new Array(count);
  }

  onDelete(index: number, item: any) {
    this.extraImagesDelete.emit({ index, item });
  }

  onShuffle(index: number, value?: string) {
    if (value) {
      this.gameSettingsService.winPattern[index].cashPrizeValue =
        this.cashPrizeValue;
    }
    this.shuffle.emit(index);
  }
}
